import React from 'react';
import QuizQuestion from './QuizQuestion.react';
import QuizStore from './../../stores/QuizStore.js';
import QuizActionCreators from './../../actions/QuizActionCreators.js';

class QuizStart extends React.Component {
  componentDidMount() {

  }

  render() {
    return (
      <div className="quiz-start">
        <div className="quiz-start-logo--durex" />

        <div className="quiz-start-info">
          <div className="quiz-start-test">{op.messages.tests}</div>
          <div className="quiz-start-title">{this.props.quiz.title}</div>
          <div className="quiz-start-sub_title">{this.props.quiz.sub_title}</div>
          <div className="tac">
            <div className="quiz-start-button" onClick={e => this._handleClick(e)}>
              {op.messages.start}
            </div>
          </div>
        </div>
      </div>
    );
  }

	_handleClick = (e) => {
	  e.preventDefault();
	  this.props.click();
	};
}

module.exports = QuizStart;
